import { ApiService } from '../api.service';
import { Injectable } from '@angular/core';
import { Commande } from '../../models/Commande';

@Injectable({
  providedIn: 'root'
})
export class ReportingVenteService {

  constructor(private api: ApiService) { }

  venteNafama(data: any) {
    return this.api.post('/common/reporting/vente-nafama', data);
  }
  venteNafamaRevendeur(data: any) {
    return this.api.post('/common/reporting/vente-nafama-revendeur', data);
  }
  venteNafamaRevendeurDefault(data: any) {
    return this.api.post('/common/reporting/vente-nafama-revendeur-default', data);
  }

  venteWallet(data: any) {
    return this.api.post('/common/reporting/vente-wallet', data);
  }
  venteWalletRevendeur(data: any) {
    return this.api.post('/common/reporting/vente-wallet-revendeur', data);
  }
  venteWalletRevendeurDefault(data: any) {
    return this.api.post('/common/reporting/vente-wallet-revendeur-default', data);
  }

  venteCarte(data: any) {
    return this.api.post('/common/reporting/vente-carte', data);
  }
  venteCarteRevendeur2222(data: any) {
    return this.api.post('/common/reporting/vente-carte-revendeur', data);
  }

  venteOmy(data: any) {
    return this.api.post('/common/reporting/vente-omy', data);
  }
  venteOmy2(data: any) {
    return this.api.post('/common/reporting/vente-omy2', data);
  }
  venteOmyRevendeur(data: any) {
    return this.api.post('/common/reporting/vente-omy-revendeur', data);
  }
  venteOmyRevendeur2(data: any) {
    return this.api.post('/common/reporting/vente-omy-revendeur2', data);
  }

  commandes(data: any) {
    return this.api.post('/common/reporting/commandes', data);
  }
  commandesDepotZebra(data: any) {
    return this.api.post('/common/reporting/commandes-depot-zebra', data);
  }
  commandesAchatZebra(data: any) {
    return this.api.post('/common/reporting/commandes-achat-zebra', data);
  }

  commissions(data: any) {
    return this.api.post('/common/reporting/commissions', data);
  }

  venteGlobal(data: any) {
    return this.api.post('/common/reporting/vente-global', data);
  }

  
}
